export function getTranslatedString(data?: {original?: string | null; translated?: string | null} | null) {
  return (data?.translated || data?.original) ?? '';
}
